export default __webpack_public_path__ + "static/media/Elec2.d953736d.png";